// src/routes/RDM/EcrPage.tsx
import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";

import {
  Languages,
  // Mail,
  ExternalLink,
  CalendarDays,
  CheckCircle2,
} from "lucide-react";
import { EcrLang, ECR_CONTENT } from "../../i18n/ecrFullContent";
import HeaderImage from "../../components/HeaderImage";


const EcrCallPage: React.FC = () => {
  const [lang, setLang] = useState<EcrLang>("en");



  // Optional: honor ?lang=en|fr|pt
  useEffect(() => {
    const q = (
      new URL(window.location.href).searchParams.get("lang") || ""
    ).toLowerCase();
    if (q === "fr" || q === "pt" || q === "en") setLang(q as EcrLang);
  }, []);

  const copy = useMemo(() => ECR_CONTENT[lang], [lang]);



  return (
    <>
      <HeaderImage image="/assets/images/backgrounds/ecr-call.jpg" />

      {/* Lock this page to the original language copies (no Google auto-translate) */}
      <div className="notranslate" translate="no">
        {/* HERO */}
        <section className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-primary/10 via-transparent to-transparent pointer-events-none" />
          <div className="max-w-5xl mx-auto pt-28 px-4 sm:px-6 lg:px-8">
            <div className="flex justify-end gap-2 mb-4">
              {(["en", "fr", "pt"] as EcrLang[]).map((l) => (
                <button
                  key={l}
                  onClick={() => setLang(l)}
                  className={`inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-medium transition ${
                    lang === l
                      ? "bg-primary text-primary-foreground border-primary"
                      : "border-border text-foreground hover:bg-card"
                  }`}
                  aria-pressed={lang === l}
                >
                  <Languages className="w-3.5 h-3.5" /> {l.toUpperCase()}
                </button>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
             
            >
                  <h2 className="text-center text-xxl font-semibold text-foreground uppercase">
                {copy.title}
          </h2>
              <p className="mt-1 text-xs sm:text-sm text-primary/80 font-semibold tracking-wide text-center">
                {copy.call}
              </p>
              <div   className="text-sm text-foreground mb-4 news-content" dangerouslySetInnerHTML={{__html: copy.intro}}/>

            </motion.div>
          </div>
        </section>

        {/* WHO SHOULD APPLY */}
        <section className="max-w-5xl mx-auto mt-10 px-4 sm:px-6 lg:px-8">
          <h3 className="text-lg sm:text-xl font-semibold mb-2">
            {copy.whoTitle}
          </h3>
          <p className="text-sm text-foreground/80 mb-2">{copy.whoLead}</p>
          <ul className="space-y-2">
            {copy.who.map((li, i) => (
              <li
                key={i}
                className="text-sm text-foreground flex items-start gap-2"
              >
                <CheckCircle2 className="w-4 h-4 mt-0.5 text-primary shrink-0" />
                <span>{li}</span>
              </li>
            ))}
          </ul>
          {copy.whoTail && (
            <p className="text-sm italic text-foreground/90 mt-3">NB. {copy.whoTail}</p>
          )}
        </section>

        {/* HOW TO APPLY */}
        <section
          id="apply"
          className="max-w-5xl mx-auto my-10 px-4 sm:px-6 lg:px-8"
        >
          <h3 className="text-lg sm:text-xl font-semibold mb-2">
            {copy.howTitle}
          </h3>
          {copy.howLead && (
            <p className="text-sm text-foreground/90">{copy.howLead}</p>
          )}

          <h4 className="text-sm font-semibold mt-6">{copy.provideTitle}</h4>
          <ul className="space-y-2 mt-1">
            {copy.provide.map((li, i) => (
              <li
                key={i}
                className="text-sm text-foreground flex items-start gap-2"
              >
                <CheckCircle2 className="w-4 h-4 mt-0.5 text-primary shrink-0" />
                <span>{li}</span>
              </li>
            ))}
          </ul>

          <p className="text-sm text-foreground mt-4 flex items-center gap-2">
            <CalendarDays className="w-4 h-4 text-primary" />
            {copy.deadline} <span className="font-bold text-red-500">{copy.deadlineDate}</span>
          </p>

                    <div className="mt-2">
            <a
              href={copy.eoiUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-md bg-primary text-primary-foreground px-4 py-2 text-xs font-semibold hover:opacity-90 transition"
            >
              {lang === "fr"
                ? "Cliquez pour postuler"
                : lang === "pt"
                  ? "Candidatar-se"
                  : "Click to apply"}
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>

          {/* <p className="text-sm text-foreground mt-2 flex items-center gap-2">
            <Mail className="w-4 h-4 text-primary" />
            <a href="mailto:libsense@ren.africa" className="underline">
              libsense@ren.africa
            </a>
          </p> */}

          <p className="text-sm text-foreground/90 mt-4">{copy.closing}</p>
        </section>

      </div>
    </>
  );
};

export default EcrCallPage;
